import type { EstadoDaSessao } from '@/shared/sessao/contexto';
import type { Situacao } from '../ui/entrada';

/**
 * De estado da sessão para situação da tela de entrada.
 *
 * Pura, para o mapeamento ser provado sem montar nada. `expirado` vira
 * `sessao-expirada` por completude — hoje a casca cuida dele, com a aplicação
 * de pé e o rascunho na tela, e a entrada não chega a ser montada.
 */
export function situacaoDe(estado: EstadoDaSessao): Situacao {
  switch (estado.nome) {
    case 'anonimo':
      /*
       * Uma situação, e não duas.
       *
       * Antes o slug decidia entre perguntar a organização e confirmá-la —
       * porque o realm era dela, e o navegador precisava saber para onde
       * mandar o login. Agora a senha é conferida num lugar só, e a
       * organização é escolhida DEPOIS, na tela própria.
       */
      return 'entrar';
    case 'saiu':
      return 'saiu';
    case 'erro':
      return estado.tipo;
    case 'expirado':
      return 'sessao-expirada';
    /*
     * `escolhendo` também é "voltando", e ele nunca chega aqui.
     *
     * Quem está escolhendo revenda já provou quem é — a tela dele é a da
     * escolha, montada pelo roteador antes da entrada. O caso existe para o
     * `switch` continuar exaustivo: sem ele, um estado novo passaria despercebido
     * e a função devolveria `undefined` para um tipo que não o aceita.
     */
    case 'escolhendo':
      // A escolha é uma situação DESTA tela: mesmo enquadramento, mesma marca,
      // e só o miolo troca. Ver o comentário da situação em `entrada.tsx`.
      return 'escolher';
    case 'indeterminado':
    case 'autenticado':
      return 'voltando';
  }
}
